var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Resolves the id of the single profile that represents a reservation.
 * Falls back to the first linked profile id when no explicit primary is set.
 */
export var getPrimaryProfileId = function (reservation) {
    var _a, _b;
    return ((_a = reservation === null || reservation === void 0 ? void 0 : reservation.primaryProfileId) !== null && _a !== void 0 ? _a : (_b = reservation === null || reservation === void 0 ? void 0 : reservation.profileIds) === null || _b === void 0 ? void 0 : _b.find(function (profileId) { return Boolean(profileId); }));
};
/**
 * Profile ids of a reservation, primary first and without duplicates.
 */
export var getOrderedReservationProfileIds = function (reservation) {
    var _a;
    return (Array.from(new Set(__spreadArray([
        reservation === null || reservation === void 0 ? void 0 : reservation.primaryProfileId
    ], ((_a = reservation === null || reservation === void 0 ? void 0 : reservation.profileIds) !== null && _a !== void 0 ? _a : []), true).filter(function (profileId) { return Boolean(profileId); }))));
};
var matchesProfileId = function (profile, profileId) { var _a; return profile.id === profileId || Boolean((_a = profile.mergedChildrenIds) === null || _a === void 0 ? void 0 : _a.includes(profileId)); };
/**
 * Resolves the single profile representing a reservation from a list of profiles.
 * The primary profile id wins; the remaining linked profile ids act as a fallback
 * so a guest is still resolved when the primary profile is missing from the list.
 */
export var getPrimaryProfile = function (reservation, profiles) {
    if (!(profiles === null || profiles === void 0 ? void 0 : profiles.length))
        return undefined;
    var _loop_1 = function (profileId) {
        var profile = profiles.find(function (candidate) { return matchesProfileId(candidate, profileId); });
        if (profile)
            return { value: profile };
    };
    for (var _i = 0, _a = getOrderedReservationProfileIds(reservation); _i < _a.length; _i++) {
        var profileId = _a[_i];
        var state_1 = _loop_1(profileId);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return undefined;
};
